import { call, put, takeLatest } from "redux-saga/effects";
import apiClient from "../../api/apiClient";
import {
  createIrrigationTypeSuccess,
  createIrrigationTypeFailure,
  createIrrigationTypeStart,
  updateIrrigationTypeSuccess,
  updateIrrigationTypeFailure,
  updateIrrigationTypeStart,
  deleteIrrigationTypeSuccess,
  deleteIrrigationTypeFailure,
  deleteIrrigationTypeStart,
} from "../../store/features/irrigationType/irrigationTypeSlice";
import { fetchIrrigationTypesStart } from "../../store/features/irrigationTypes/irrigationTypesSlice";

const path = "/api/v1/irrigation_system/irrigation_system/";

// CREATE
const createIrrigationTypeApi = async ({ data, accessToken }) => {
  try {
    const client = apiClient(accessToken, path);
    const response = await client.post("/", data);
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: error.message };
  }
};

function* handleCreateIrrigationTypeSaga(action) {
  try {
    const data = yield call(createIrrigationTypeApi, action.payload);
    yield put(createIrrigationTypeSuccess(data));
  } catch (error) {
    yield put(createIrrigationTypeFailure(error));
  }
}

// UPDATE
const updateIrrigationTypeApi = async ({
  data,
  accessToken,
  irrigationTypeId,
}) => {
  try {
    const client = apiClient(accessToken, path);
    const response = await client.put(`${irrigationTypeId}/`, data);
    return response.data;
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message;
    throw new Error(errorMessage);
  }
};

function* handleUpdateIrrigationTypeSaga(action) {
  try {
    const data = yield call(updateIrrigationTypeApi, action.payload);
    yield put(updateIrrigationTypeSuccess(data));
  } catch (error) {
    yield put(updateIrrigationTypeFailure(error.message));
  }
}

// DELETE
const deleteIrrigationTypeApi = async ({ accessToken, irrigationTypeId }) => {
  try {
    const client = apiClient(accessToken, path);
    const response = await client.delete(`/${irrigationTypeId}/`);
    return response.data;
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message;
    throw new Error(errorMessage);
  }
};

function* handleDeleteIrrigationTypeSaga(action) {
  try {
    const data = yield call(deleteIrrigationTypeApi, action.payload);
    yield put(deleteIrrigationTypeSuccess(data));
    yield put(
      fetchIrrigationTypesStart({ accessToken: action.payload.accessToken })
    );
  } catch (error) {
    yield put(deleteIrrigationTypeFailure(error.message));
  }
}

export default function* irrigationTypeSaga() {
  yield takeLatest(createIrrigationTypeStart, handleCreateIrrigationTypeSaga);
  yield takeLatest(updateIrrigationTypeStart, handleUpdateIrrigationTypeSaga);
  yield takeLatest(deleteIrrigationTypeStart, handleDeleteIrrigationTypeSaga);
}
